/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const DidCommMessageSend: core.serialization.ObjectSchema<
    serializers.DidCommMessageSend.Raw,
    Truvity.DidCommMessageSend
> = core.serialization.object({
    credentials: core.serialization.list(core.serialization.string()).optional(),
    disableTransitiveClosure: core.serialization.property(
        'disable_transitive_closure',
        core.serialization.boolean().optional(),
    ),
    files: core.serialization.list(core.serialization.string()).optional(),
    keyId: core.serialization.property('key_id', core.serialization.string()),
    presentations: core.serialization.list(core.serialization.string()).optional(),
    to: core.serialization.string(),
});

export declare namespace DidCommMessageSend {
    export interface Raw {
        credentials?: string[] | null;
        disable_transitive_closure?: boolean | null;
        files?: string[] | null;
        key_id: string;
        presentations?: string[] | null;
        to: string;
    }
}
